angular.module("Agnes")
    .controller("HomeController", [
        "$scope", "$activity", "$http", "$notification", "$oidc",
        function ($scope, $activity, $http, $notification, oidc) {
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            $scope.refresh = function () {
                $activity.start();
                $http
                    .get("/api/technical-support/pending/" + $scope.$storage.repairer.id + "/count", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.pendingsCount = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                $scope.refresh();
        }
    ]);